import store from "../store.js";
import keviApi from "../keviApi";
import Vue from "vue";
const state = () => ({
    status: "loading",
    filters: {},
    list: [],
    newMessages: 0,
    totalMessages: 0,
    currentPage: 1,
    lastPage: 1,
    perPage: 50,
});

const actions = {
    checkNewMessages({ commit }) {
        let options = keviApi.getOptions("inbox/messages/count-new", "GET");
        Vue.http(options).then((response) => {
            commit("setNewMessages", response.body.newMessages);
        });
    },
    loadList({ commit }, filters) {
        commit("setStatus", "loading");
        commit("setFilters", filters || {});
        let options = keviApi.getOptions("inbox/messages", "GET", { filters });
        return Vue.http(options)
            .then((response) => {
                const body = JSON.parse(JSON.stringify(response.body));
                commit("setList", body.data || []);
                commit("setTotalMessages", body.meta.total);
                commit("setPageMeta", {
                    currentPage: body.meta.current_page,
                    lastPage: body.meta.last_page || 1,
                    perPage: body.meta.per_page,
                });
            })
            .finally(() => {
                commit("setStatus", "ready");
            });
    },
    applyTag({ commit }, { messageId, tag_id, name }) {
        const payload = tag_id ? { tag_id } : { name };
        let options = keviApi.getOptions(
            "answers/" + messageId + "/tags",
            "POST",
            payload,
        );
        return Vue.http(options).then((response) => {
            commit("setMessageTags", {
                messageId,
                tags: response.body.tags,
            });
            return response.body;
        });
    },
    removeTag({ commit }, { messageId, tagId }) {
        let options = keviApi.getOptions(
            "answers/" + messageId + "/tags/" + tagId,
            "DELETE",
        );
        return Vue.http(options).then((response) => {
            commit("setMessageTags", {
                messageId,
                tags: response.body.tags,
            });
            return response.body;
        });
    },
    markRead({ commit, dispatch }, messageId) {
        let options = keviApi.getOptions(
            "inbox/message/" + messageId + "/read",
            "POST",
        );
        return Vue.http(options).then((response) => {
            commit("setMessageRead", {
                messageId,
                readAt: response.body.read_at,
            });
            dispatch("checkNewMessages");
        });
    },
    markUnread({ commit, dispatch }, messageId) {
        let options = keviApi.getOptions(
            "inbox/message/" + messageId + "/unread",
            "POST",
        );
        return Vue.http(options).then(() => {
            commit("setMessageRead", { messageId, readAt: null });
            dispatch("checkNewMessages");
        });
    },
    markAllRead({ commit, dispatch }) {
        let options = keviApi.getOptions("inbox/messages/read-all", "POST");
        return Vue.http(options).then(() => {
            commit("setAllRead");
            dispatch("checkNewMessages");
        });
    },
};

const mutations = {
    setStatus(state, status) {
        state.status = status;
    },
    resetData(state) {
        state.list = [];
        state.totalMessages = 0;
        state.currentPage = 1;
        state.lastPage = 1;
    },
    setList(state, data) {
        state.list = data;
    },
    setTotalMessages(state, total) {
        state.totalMessages = total;
    },
    setPageMeta(state, { currentPage, lastPage, perPage }) {
        state.currentPage = currentPage;
        state.lastPage = lastPage;
        if (perPage) {
            state.perPage = perPage;
        }
    },
    setFilters(state, data) {
        state.filters = JSON.parse(JSON.stringify(data));
    },
    setNewMessages(state, counter) {
        state.newMessages = counter;
    },
    setMessageRead(state, { messageId, readAt }) {
        state.list = state.list.map((message) => {
            if (String(message.id) === String(messageId)) {
                const wasUnread = !message.read_at;
                const willBeRead = !!readAt;
                Vue.set(message, "read_at", readAt);
                if (wasUnread && willBeRead) {
                    state.newMessages = Math.max(0, (state.newMessages || 0) - 1);
                } else if (!wasUnread && !willBeRead) {
                    state.newMessages = (state.newMessages || 0) + 1;
                }
            }
            return message;
        });
    },
    setAllRead(state) {
        const now = new Date().toISOString();
        state.list.forEach((message) => {
            if (!message.read_at) {
                Vue.set(message, "read_at", now);
            }
        });
        state.newMessages = 0;
    },
    setMessageTags(state, { messageId, tags }) {
        state.list = state.list.map((message) => {
            if (message.id === messageId) {
                Vue.set(message, "tags", tags);
            }
            return message;
        });
    },
    removeMessage(state, messageId) {
        const wasUnread = state.list.some(
            (message) =>
                String(message.id) === String(messageId) && !message.read_at,
        );
        state.list = state.list.filter(
            (message) => String(message.id) !== String(messageId),
        );
        state.totalMessages = Math.max(0, (state.totalMessages || 0) - 1);
        if (wasUnread) {
            state.newMessages = Math.max(0, (state.newMessages || 0) - 1);
        }
    },
};

store.registerModule("inbox", {
    namespaced: true,
    state,
    actions,
    mutations,
});

export default store;
